import { render, staticRenderFns } from "./address.vue?vue&type=template&id=ee1f9064&"
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee1f9064')) {
      api.createRecord('ee1f9064', component.options)
    } else {
      api.reload('ee1f9064', component.options)
    }
    module.hot.accept("./address.vue?vue&type=template&id=ee1f9064&", function () {
      api.rerender('ee1f9064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/risk/address.vue"
export default component.exports